//  左侧消息头部组件

import React, { useEffect, useMemo, useState, useCallback } from "react";
import "./index.less";
import IconFont from "@/components/icon";
import { connect } from "dva";
import { MessageCategoryType, MessageNotifyType } from "@/types/chat/enum";
import ChatState from "@/types/chat/State";
import { WithTranslation, withTranslation } from "react-i18next";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import lifecycle from "page-lifecycle";
import { FocusSDK } from "@/utils";
import dayjs from "dayjs";
import { usePrevious, useThrottle } from "@/utils/chat/index";
import { debounce, throttle } from "lodash";
import { getNetCheckUrl } from "@/config/config";
import Bus from "@/utils/bus";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
interface MsgNotificationProps {
  isAllFollow?: boolean;
  closeAllFollow?: (isAllFollow: boolean) => void;
}
interface DvaDispatchProps {
  changeNotifyType: Function;
  changeCategory: Function;
}

type IProps = Readonly<MsgNotificationProps & DvaDispatchProps & WithTranslation & ChatState>;

function MsgNotification(props: IProps) {
  const { topCount, selectedNotifyType, notifyType, t, isAllFollow, connectState } = props;
  const [changeActive, setChangeActive] = useState(false);
  const preActive = usePrevious(changeActive);

  // 点击消息提醒类型 全部 已读 重要
  const changeNotifyTypeFn = (key: MessageNotifyType) => {
    props.changeNotifyType({ selectedNotifyType: key });
  };

  // 点击关闭全部置顶消息列表
  const closeAllFollow = () => {
    if (props.closeAllFollow) {
      props.closeAllFollow(false);
    }
  };

  // 激活会话窗口时，更新连接状态
  const changeHidden = (event: any) => {
    const { newState } = event;
    if (newState === "active") {
      setChangeActive(true);
    } else {
      setChangeActive(false);
    }
  };

  useEffect(() => {
    lifecycle.addEventListener("statechange", changeHidden);
    return () => {
      lifecycle.removeEventListener("statechange", changeHidden);
    };
  }, []);

  const netCheck = useCallback(() => {
    const netServer = NetworkCheck.getInstance({
      url: getNetCheckUrl(),
      checkType: UseCheckType.API
    });
    FocusSDK.printLog(`${dayjs().format("YYYY-MM-DD HH:mm:ss.SSS")},连接状态当前值检测docheck`);
    netServer.checkNet().then((isOnline) => {
      if (isOnline) {
        Bus.emit("chat:state", {
          state: ConnectState.READY
        });
      }
    });
  }, []);

  const doNetCheck = useThrottle(netCheck, 30 * 1000);

  useEffect(() => {
    if (
      [ConnectState.OFFLINE, ConnectState.CLOSED].includes(connectState.state) &&
      !preActive &&
      changeActive
    ) {
      doNetCheck();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changeActive, connectState.state, preActive]);

  let msgTitle = useMemo(() => {
    let msgTitle = t("connection-status.on-connection");
    switch (connectState.state) {
      case ConnectState.OFFLINE:
      case ConnectState.ERROR:
        msgTitle = t("connection-status.connection-closed");
        break;
      case ConnectState.CLOSED:
      case ConnectState.CONNECTING:
      case ConnectState.CONNECTED:
        msgTitle = t("connection-status.on-connection");
        break;
      case ConnectState.AUTHING:
        msgTitle = t("connection-status.on-receive");
        break;
      // case ConnectState.AUTH_FAILED:
      //     msgTitle = t('connection-status.authentication-failed');
      //     break;
      case ConnectState.AUTHED:
      case ConnectState.READY:
        // msgTitle = t(notifyType[selectedNotifyType].title);
        msgTitle = "";

        break;
    }
    return msgTitle;
  }, [connectState.state, t, changeActive]); // eslint-disable-line
  return (
    <div className="msg-notification">
        <div className="MsgHeader">
          <div className="notify-type-container">
              {Object.keys(notifyType).map((key, index) => {
                const nt = notifyType[key];
                return (
                  nt.enable && (
                    <div
                      key={index}
                      onClick={changeNotifyTypeFn.bind(null, key as MessageNotifyType)}
                      clstag={nt.clstag}
                      className={`notify-type-item ${
                        selectedNotifyType === key ? "notify-type-item-selected" : ""
                      }`}
                    >
                      <div className="notify-type-item_title">
                        <span>{t(notifyType[key].title)}</span>
                      </div>
                    </div>
                  )
                );
              })}
            </div>
        </div>
    </div>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const {
    selectedNotifyType,
    selectedCategory,
    category,
    notifyType,
    connectState,
    topCount,
    unReadCount,
    atCount
  } = chat;
  return {
    selectedNotifyType,
    selectedCategory,
    category,
    notifyType,
    connectState,
    topCount,
    unReadCount,
    atCount
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    changeNotifyType(data: { selectedNotifyType: MessageNotifyType }) {
      dispatch({ type: "chat/changeNotifyType", payload: data });
      // (偶现)桌面端筛选未读时后台切换其他应用在切换回来会话页面闪 --hujun
      // 点击消息列表的<全部><组><未读><@我>,右侧对话框清空显示空白
      // dispatch({ type: 'chat/updateSelectedSession', payload: {} });
    },
    changeCategory(data: { selectedCategory: MessageCategoryType }) {
      dispatch({ type: "chat/changeCategory", payload: data });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation("chat")(MsgNotification));
